// Default images for fallback
export const DEFAULT_DECK_AVATAR = "/images/def/deck/avatar-default.png";

/** Placeholder for texts: image that references written content (title on document-like cover) */
const PLACEHOLDER_TEXT_BASE = "https://placehold.co";

/**
 * Returns a deterministic placeholder image URL for text content that has no image.
 * Shows the title on a document-style cover so it clearly references "text".
 * @param {{ title?: string, sourceId?: string, catalogRef?: string, _id?: string }} item - Content item with optional title and id
 * @returns {string} URL for placeholder image
 */
export function getPlaceholderImageUrl(item) {
  const title = (item?.title || "").trim() || "Text";
  const text = title.length > 22 ? title.slice(0, 19) + "…" : title;
  return `${PLACEHOLDER_TEXT_BASE}/400x300/334155/e2e8f0?text=${encodeURIComponent(text)}`;
}
